export const DOMAIN =
  'https://bnlwe-es02-p-931432-unilevercom-webapp-01.azurewebsites.net';
export const vaultDomain = 'https://unilever-bbfclaims.veevavault.com';

export const environment = {
  production: false,
  apiUrl: 'https://claims-sparci.unilever.com',
  socketUrl:
    'https://bnlwe-es02-p-931432-unilevercom-webapp-01.azurewebsites.net',
  msalConfig: {
    auth: {
      clientId: '9cadbd36-4b37-43a9-86d6-3c99442c251d',
      authority:
        'https://login.microsoftonline.com/f66fae02-5d36-495b-bfe0-78a6ff9f8e6e/',
      // redirectUri: 'http://localhost:4200',
      redirectUri: 'https://claims-sparci.unilever.com/',
    },
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/.default',
  },
};
